import { css } from '@mui/material'
import { Theme } from '@mui/material/styles'

export const sidebarButtonsContainer = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(3)};
  width: 100%;
`
export const sidebarButtonsInnerContainer = (theme: Theme, loaded: boolean) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)}
  opacity: ${loaded ? 1 : 0};
  transition: opacity 0.3s ease-in-out;
  width: 100%;
`
